// src/pages/Cancellation/index.js
import React from "react";
import { Routes, Route } from "react-router-dom";

// Cancellation Components
import CancellationWizard from "./CancellationWizard";
import CancellationStatus from "./CancellationStatus";
import PendingCancellations from "./PendingCancellations";

// Refund Components
import RefundManagement from "./RefundManagement";
import RefundDetails from "./RefundDetails";

// Collection Components
import CollectionManagement from "./CollectionManagement";
import CollectionDetails from "./CollectionDetails";

// Statistics
import CancellationStatistics from "./CancellationStatistics";

// Protected Route Wrapper (if you have one)
// import ProtectedRoute from "../../components/ProtectedRoute";

/**
 * Cancellation Routes
 * All routes related to plan cancellations, refunds, and collections
 */
const CancellationRoutes = () => {
  return (
    <Routes>
      {/* ==================== CANCELLATION WORKFLOW ==================== */}
      <Route path="/:planId/cancel" element={<CancellationWizard />} />
      <Route path="/:planId/status" element={<CancellationStatus />} />
      <Route path="/pending" element={<PendingCancellations />} />

      {/* ==================== REFUND MANAGEMENT ==================== */}
      <Route path="/refunds" element={<RefundManagement />} />
      <Route path="/refunds/:refundId" element={<RefundDetails />} />

      {/* ==================== COLLECTION MANAGEMENT ==================== */}
      <Route path="/collections" element={<CollectionManagement />} />
      <Route
        path="/collections/:collectionId"
        element={<CollectionDetails />}
      />

      {/* ==================== STATISTICS & ANALYTICS ==================== */}
      <Route path="/statistics" element={<CancellationStatistics />} />
    </Routes>
  );
};

export default CancellationRoutes;
